// 拼装协议DV1.0.2版本处理
// 这个版本的主要特征：为了减少通讯量，将关键字进行了缩写。
// 比如：number 缩写为nu; rgb 缩写为r;  color 缩写为c; fontRgb 缩写为f;  group 缩写为g; name 缩写为na;

// 根据输入信息进行数据的还原，将缩写的关键字还原为原始关键字
// 例如：nu -> number; r -> rgb; c -> color; f -> fontRgb; g -> group; na -> name
function assembleProtocolDV102(data) 
{

    console.log("assembleProtocolDV102", data);

    // 将data 拷贝到newdata中
    let newdata = data;
    // 先判断data是否为string，如果是则直接替换; 如果是json则先转换为string再替换
    if (typeof data === 'object')
    {
        console.log("data is object");

        if (data.hasOwnProperty("data"))
        {
            let imgdata = data.data[0];
            let version = imgdata.version;
            if (version === "DV1.0.0")
            {
                console.log("已经是DV1.0.0版本，不需要转换");

                // 如果不是DV1.0.2版本，则直接返回原始数据
                return data;
            }
        }
        

        newdata = JSON.stringify(data);
    }

    // 替换newdata中的关键字
    newdata = newdata.replace(/"u/g, '"usednum');
    newdata = newdata.replace(/"nu/g, '"number');
    newdata = newdata.replace(/"r/g, '"rgb');
    newdata = newdata.replace(/"c/g, '"color');
    newdata = newdata.replace(/"f/g, '"fontRgb');
    newdata = newdata.replace(/"g/g, '"group');
    newdata = newdata.replace(/"na/g, '"name');
    newdata = newdata.replace(/"A/g, '"Area');
    newdata = newdata.replace(/"x/g, '"startx');
    newdata = newdata.replace(/"y/g, '"starty');
    newdata = newdata.replace(/"w/g, '"width');
    newdata = newdata.replace(/"h/g, '"height');
    newdata = newdata.replace(/"d/g, '"data');
    newdata = newdata.replace(/"encode/g, '"code');

    newdata = JSON.parse(newdata);

    return newdata;
    
}


export { assembleProtocolDV102 };